import type { i18n } from 'i18next';
import { initI18next } from '@salesforce/storefront-next-runtime/i18n/client';

const I18N_READY_TIMEOUT_MS = 3000;

/**
 * Client i18next instance, initialized with the language selected during SSR.
 */
export const i18nextOnClient: i18n | undefined =
    typeof window !== 'undefined'
        ? initI18next({
              language: document.documentElement.lang || undefined,
              loadLocale: (language) => import(`@/locales/${language}/index.ts`),
          })
        : undefined;

/**
 * Waits for the active locale bundle before hydration, with a timeout so a
 * failed locale request cannot leave the page non-interactive.
 */
export function whenI18nReady(): Promise<void> {
    const instance = i18nextOnClient;
    if (!instance || instance.hasResourceBundle(instance.language, 'common')) {
        return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
        let settled = false;
        const finish = () => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            resolve();
        };
        const timer = setTimeout(finish, I18N_READY_TIMEOUT_MS);

        void instance.loadNamespaces('common', finish);
    });
}
